/* ============================================
   BEST SELLERS CAROUSEL LOGIC
   ============================================ */

if (!customElements.get("best-sellers-carousel")) {
  class BestSellersCarousel extends HTMLElement {
    constructor() {
      super();

      this.track = this.querySelector(".best-sellers__track");

      // Look outside this specific component to find its header buttons
      const section = this.closest(".best-sellers");
      if (!section) return;

      this.prevBtn = section.querySelector('[name="previous"]');
      this.nextBtn = section.querySelector('[name="next"]');

      if (!this.track || !this.prevBtn || !this.nextBtn) return;

      // Event Listeners
      this.prevBtn.addEventListener("click", () => this.scroll("prev"));
      this.nextBtn.addEventListener("click", () => this.scroll("next"));
      this.track.addEventListener("scroll", this.updateButtons.bind(this));

      // Wait for layout to settle then check button states
      window.addEventListener("resize", this.updateButtons.bind(this));
      setTimeout(() => this.updateButtons(), 100);
    }

    scroll(direction) {
      // Calculate exactly how far to scroll (Width of one item + the gap)
      const firstItem = this.track.firstElementChild;
      if (!firstItem) return;

      const itemWidth = firstItem.getBoundingClientRect().width;
      const gap = parseFloat(window.getComputedStyle(this.track).gap) || 0;
      const scrollAmount = itemWidth + gap;

      const leftPosition =
        direction === "next"
          ? this.track.scrollLeft + scrollAmount
          : this.track.scrollLeft - scrollAmount;

      this.track.scrollTo({
        left: leftPosition,
        behavior: "smooth",
      });
    }

    updateButtons() {
      // Disable Prev if at the start
      if (this.track.scrollLeft <= 0) {
        this.prevBtn.setAttribute("disabled", "disabled");
      } else {
        this.prevBtn.removeAttribute("disabled");
      }

      // Disable Next if at the end (with a 2px buffer for rounding errors)
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      if (this.track.scrollLeft >= maxScroll - 2) {
        this.nextBtn.setAttribute("disabled", "disabled");
      } else {
        this.nextBtn.removeAttribute("disabled");
      }
    }
  }

  customElements.define("best-sellers-carousel", BestSellersCarousel);
}
